import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'about-us',
    useLayout: true,
    children: [{ id: SectionsKey.AboutUs, order: 1 }]
};

export default PageStruct;
